// Zentrale Unternehmens- & Preisdaten (1:1 aus der Preisliste des Kunden)

export const CONTACT = {
  name: "ZWILLINGSWERK",
  slogan: "Zwei Brüder. Ein Ziel. Saubere Arbeit. Starke Ergebnisse.",
  phoneDisplay: "0176 209 39 646",
  phoneHref: "tel:+4917620939646",
  email: "info.zwillingswerk@gmail.com",
  emailHref: "mailto:info.zwillingswerk@gmail.com",
  street: "Johannesstraße 20",
  city: "45701 Herten",
  hours: "Mo–Fr 8:00–17:00 Uhr",
};

export const CITIES = [
  "Herten",
  "Recklinghausen",
  "Gelsenkirchen",
  "Marl",
  "Herne",
  "Gladbeck",
  "Bottrop",
  "Castrop-Rauxel",
  "Datteln",
  "Oer-Erkenschwick",
];

export const HINWEISE = {
  anfahrt:
    "Anfahrt im Umkreis von 20 km inklusive. Darüber hinaus: 0,70 € pro Kilometer.",
  entsorgung: "Entsorgung von Grünschnitt & Abfällen nach Aufwand.",
  mindest:
    "Mindestauftragswert: Privatkunden 69,00 € netto (82,11 € brutto) · Gewerbe 99,00 € netto (117,81 € brutto).",
  zahlung:
    "Rechnungsstellung nach Leistungserbringung. Zahlungsziel: 7 Tage (bei Stammkunden nach Absprache).",
};

export const GARTEN_ROWS = [
  { name: "Rasen mähen (inkl. Kanten)", unit: "pro m²", netto: "0,18 €", brutto: "0,21 €" },
  { name: "Rasenkanten schneiden", unit: "pro lfm", netto: "0,15 €", brutto: "0,18 €" },
  { name: "Heckenschnitt (bis 2 m)", unit: "pro lfm", netto: "5,00 €", brutto: "5,95 €" },
  { name: "Heckenrückschnitt (über 2 m)", unit: "pro lfm", netto: "8,00 €", brutto: "9,52 €" },
  { name: "Sträucher schneiden", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Baum- und Gehölzschnitt", unit: "pro Std.", netto: "55,00 €", brutto: "65,45 €" },
  { name: "Beetpflege", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Unkraut entfernen", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Laub entfernen", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Vertikutieren", unit: "pro m²", netto: "1,50 €", brutto: "1,79 €" },
  { name: "Rasen nachsäen", unit: "pro m²", netto: "3,00 €", brutto: "3,57 €" },
  { name: "Grünschnitt sammeln & laden", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Grünschnitt entsorgen", unit: "pro m²", netto: "30,00 €", brutto: "35,70 €" },
  { name: "Frühjahrs-/Herbstputz Garten", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Bewässerung", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Gartenpflege-Abo (monatlich)", unit: "pro Monat", netto: "ab 99,00 €", brutto: "ab 117,81 €", highlight: true },
];

export const HAUSMEISTER_ROWS = [
  { name: "Objektkontrolle", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Mülltonnenservice", unit: "je Termin", netto: "25,00 €", brutto: "29,75 €" },
  { name: "Außenanlagenpflege", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Hof- und Wegepflege", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Kleinere Reparaturen*", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Treppenhausreinigung", unit: "pro m²", netto: "3,00 €", brutto: "3,57 €" },
  { name: "Kellerreinigung", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Gemeinschaftsräume", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Winterdienst", unit: "je Einsatz", netto: "49,00 €", brutto: "58,31 €" },
  { name: "Bereitschaftsdienst", unit: "pro Monat", netto: "49,00 €", brutto: "58,31 €" },
];

export const MONATSVERTRAEGE = [
  {
    name: "Paket Basic",
    price: "ab 199 €",
    tag: "Kleines Objekt",
    features: ["Kontrollgänge", "Mülltonnenservice", "Außenkontrolle"],
    highlight: false,
  },
  {
    name: "Paket Standard",
    price: "ab 299 €",
    tag: "Beliebteste Wahl",
    features: ["Alle Leistungen aus Basic", "Treppenhausreinigung", "Kleine Pflegearbeiten"],
    highlight: true,
  },
  {
    name: "Paket Komplett",
    price: "ab 499 €",
    tag: "Rundum-Sorglos",
    features: ["Alle Leistungen aus Standard", "Gartenpflege", "Saisonale Arbeiten"],
    highlight: false,
  },
];

export const AUSZUG_UMFANG = [
  "Küche inkl. Geräte (Backofen, Herd, Kühlschrank)",
  "Bad inkl. Dusche/Badewanne & WC",
  "Böden saugen und wischen",
  "Türen und Türrahmen",
  "Fenster & Fensterrahmen (optional)",
  "Heizkörper",
  "Fußleisten",
  "Schränke innen/außen (optional)",
  "Spinnweben entfernen",
  "Keller/Abstellraum",
  "Balkon/Terrasse",
  "Endkontrolle für die Wohnungsübergabe",
];

export const AUSZUG_ROWS = [
  { name: "1-Zimmer-Wohnung", unit: "Komplettreinigung", netto: "ab 149,00 €", brutto: "ab 177,31 €" },
  { name: "2-Zimmer-Wohnung", unit: "Komplettreinigung", netto: "ab 199,00 €", brutto: "ab 236,81 €" },
  { name: "3-Zimmer-Wohnung", unit: "Komplettreinigung", netto: "ab 279,00 €", brutto: "ab 312,01 €" },
  { name: "4-Zimmer-Wohnung", unit: "Komplettreinigung", netto: "ab 349,00 €", brutto: "ab 415,31 €" },
  { name: "5-Zimmer-Wohnung", unit: "Komplettreinigung", netto: "ab 449,00 €", brutto: "ab 534,31 €" },
  { name: "Reihenhaus", unit: "Komplettreinigung", netto: "ab 359,00 €", brutto: "ab 474,81 €" },
  { name: "Einfamilienhaus", unit: "Komplettreinigung", netto: "ab 499,00 €", brutto: "ab 593,81 €" },
];

export const AUSZUG_EXTRA = [
  { name: "Fenster (pro Fenster)", price: "5,00–10,00 €" },
  { name: "Backofen intensiv", price: "ab 25,00 €" },
  { name: "Kühlschrank", price: "ab 20,00 €" },
  { name: "Keller/Abstellraum", price: "ab 30,00 €" },
  { name: "Starke Verschmutzung", price: "nach Besichtigung" },
];

export const WINTER_ROWS = [
  { name: "Einsatz (kleine Fläche)", unit: "je Einsatz", netto: "49,00 €", brutto: "58,31 €" },
  { name: "Einsatz (Mehrfamilienhaus/Gewerbe)", unit: "je Einsatz", netto: "69,00 €", brutto: "82,11 €" },
  { name: "Streudienst", unit: "je Einsatz", netto: "15,00 €", brutto: "17,85 €" },
  { name: "Saisonvertrag (Einfamilienhaus)", unit: "pro Saison", netto: "ab 350,00 €", brutto: "ab 416,50 €", highlight: true },
  { name: "Saisonvertrag (Mehrfamilienhaus)", unit: "pro Saison", netto: "ab 600,00 €", brutto: "ab 714,00 €", highlight: true },
  { name: "Flächenpreis (Gewerbe)", unit: "pro m²", netto: "0,80–2,50 €", brutto: "0,95–2,98 €" },
];

export const WINTER_UMFANG = [
  "Schneeräumung (Gehwege, Einfahrten, Höfe, Parkplätze)",
  "Streudienst (bedarfsgerecht)",
  "Sicherheitskontrollen",
  "Saisonverträge für Privat & Gewerbe",
];

export const WEITERE_ROWS = [
  { name: "Umzugsservice (Ein-/Auszug)", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Möbelmontage", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Kleine Reparaturen*", unit: "pro Std.", netto: "45,00 €", brutto: "53,55 €" },
  { name: "Entrümpelung", unit: "pro m²", netto: "80,00 €", brutto: "95,20 €" },
  { name: "Haushaltsauflösung", unit: "nach Aufwand", netto: "auf Anfrage", brutto: "auf Anfrage" },
  { name: "Pflasterreinigung", unit: "pro m²", netto: "2,50 €", brutto: "2,98 €" },
  { name: "Terrassenreinigung", unit: "pro m²", netto: "2,50 €", brutto: "2,98 €" },
  { name: "Fassadenreinigung", unit: "pro m²", netto: "5,00 €", brutto: "5,95 €" },
  { name: "Dachrinnenreinigung", unit: "pro lfm", netto: "4,00 €", brutto: "4,76 €" },
  { name: "Graffitientfernung", unit: "pro m²", netto: "10,00 €", brutto: "11,90 €" },
];

export const NAV_LINKS = [
  { to: "/", label: "Start" },
  { to: "/gartenservice", label: "Gartenservice" },
  { to: "/hausmeisterservice", label: "Hausmeisterservice" },
  { to: "/auszugsreinigung", label: "Auszugsreinigung" },
  { to: "/winterdienst", label: "Winterdienst" },
  { to: "/weitere-leistungen", label: "Weitere Leistungen" },
  { to: "/ueber-uns", label: "Über uns" },
  { to: "/kontakt", label: "Kontakt" },
];
